// Product Card Link Fix
// This script ensures product cards are properly clickable

document.addEventListener('DOMContentLoaded', function() {
  // Fix for product cards in featured collection
  const productCards = document.querySelectorAll('.card-wrapper.product-card-wrapper');
  
  productCards.forEach(function(card) {
    // Get the product link
    const productLink = card.querySelector('.full-unstyled-link');
    
    if (productLink) {
      // Make the card clickable, but don't trigger when clicking on buttons
      card.addEventListener('click', function(event) {
        // Don't navigate if clicking on a button, link, or other interactive element
        if (!event.target.closest('button') && 
            !event.target.closest('.product-hover') && 
            !event.target.closest('.quick-add') &&
            !event.target.closest('a:not(.full-unstyled-link)')) {
          // Navigate to the product page
          window.location.href = productLink.getAttribute('href');
        }
      });
    }
    
    // Make sure the product hover buttons don't trigger the card click
    const productHoverButtons = card.querySelectorAll('.product-hover button, .product-hover a, .quick-add button');
    
    productHoverButtons.forEach(function(button) {
      button.addEventListener('click', function(event) {
        // Stop the click from bubbling up to the card
        event.stopPropagation();
      });
    });
  });
});
